/* MiniBea dual-handle price slider.
   Shopify's price facet is two number inputs. This overlays a slider on them and
   keeps the inputs as the source of truth, so the theme's own filter form still
   submits exactly as before. The facets markup is replaced on every filter change,
   so a MutationObserver re-attaches the slider after each re-render. */
(function () {
  'use strict';
  var MONEY = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

  function money(el, n) {
    var c = el.querySelector('.field-currency');
    return (c ? c.textContent.trim() : '€') + MONEY.format(Math.round(n));
  }

  function build(range) {
    if (range.dataset.mbSlider === '1') return;
    var gte = range.querySelector('input[name="filter.v.price.gte"]');
    var lte = range.querySelector('input[name="filter.v.price.lte"]');
    if (!gte || !lte) return;
    var max = parseFloat(lte.getAttribute('max') || gte.getAttribute('max') || '0');
    if (!(max > 0)) return;
    // round the slider ceiling up, or a €342,95 max leaves the bar short of the end
    var top = Math.ceil(max);
    range.dataset.mbSlider = '1';

    var lo = gte.value === '' ? 0 : Math.max(0, parseFloat(gte.value));
    var hi = lte.value === '' ? top : Math.min(top, parseFloat(lte.value));
    if (lo > hi) { var t = lo; lo = hi; hi = t; }

    var wrap = document.createElement('div');
    wrap.className = 'mb-price';
    wrap.innerHTML =
      '<div class="mb-price__scale"><span class="mb-price__lo"></span><span class="mb-price__hi"></span></div>' +
      '<div class="mb-price__track">' +
        '<span class="mb-price__rail"></span><span class="mb-price__bar"></span>' +
        '<input class="mb-price__in mb-price__in--min" type="range" min="0" max="' + top + '" step="1">' +
        '<input class="mb-price__in mb-price__in--max" type="range" min="0" max="' + top + '" step="1">' +
      '</div>';
    range.parentNode.insertBefore(wrap, range);

    var minIn = wrap.querySelector('.mb-price__in--min');
    var maxIn = wrap.querySelector('.mb-price__in--max');
    var bar   = wrap.querySelector('.mb-price__bar');
    var loEl  = wrap.querySelector('.mb-price__lo');
    var hiEl  = wrap.querySelector('.mb-price__hi');
    minIn.value = lo; maxIn.value = hi;
    minIn.setAttribute('aria-label', 'Minimumprijs');
    maxIn.setAttribute('aria-label', 'Maximumprijs');

    function paint() {
      var a = Math.min(+minIn.value, +maxIn.value);
      var b = Math.max(+minIn.value, +maxIn.value);
      bar.style.left  = (a / top * 100) + '%';
      bar.style.width = ((b - a) / top * 100) + '%';
      loEl.textContent = money(range, a);
      hiEl.textContent = b >= top ? money(range, max) : money(range, b);
      minIn.setAttribute('aria-valuetext', loEl.textContent);
      maxIn.setAttribute('aria-valuetext', hiEl.textContent);
    }

    function commit() {
      var a = Math.min(+minIn.value, +maxIn.value);
      var b = Math.max(+minIn.value, +maxIn.value);
      // blank means "no bound", which is what the theme expects for a full range
      gte.value = a <= 0 ? '' : String(a);
      lte.value = b >= top ? '' : String(b);
      [gte, lte].forEach(function (i) {
        i.dispatchEvent(new Event('change', { bubbles: true }));
        i.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    // dragging only repaints; the filter re-runs when the handle is released
    minIn.addEventListener('input', paint);
    maxIn.addEventListener('input', paint);
    minIn.addEventListener('change', commit);
    maxIn.addEventListener('change', commit);
    // if anything else edits the number fields, follow them
    gte.addEventListener('change', function () {
      minIn.value = gte.value === '' ? 0 : gte.value; paint();
    });
    lte.addEventListener('change', function () {
      maxIn.value = lte.value === '' ? top : lte.value; paint();
    });
    paint();
  }

  function scan(root) {
    (root || document).querySelectorAll('price-range.facets__price').forEach(build);
  }

  function boot() {
    scan();
    // the facets block is re-rendered on every filter change
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { scan(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
